import {useState} from 'react';
import {useCart} from '@shopify/hydrogen';
import clsx from 'clsx';
import {ReactComponent as Cart} from '~/assets/icons/cart.svg';
import {ReactComponent as Profile} from '~/assets/icons/profile.svg';
import {CartOverlay} from '~/components/cart/CartOverlay.client';
import {trackClickEvent} from '~/utils/trackClickEvent';
/**
 * UserNav component that previews total items and has buttons to navigate to user's cart/profile.
 * Lives as a separate child client component due to use of the cart context
 */

export function UserNav() {
  const {totalQuantity} = useCart();
  const [cartOverlayIsVisible, setCartOverlayIsVisible] = useState(false);
  function toggleCartOverlayVisibility() {
    setCartOverlayIsVisible((cartOverlayIsVisible) => !cartOverlayIsVisible);
  }

  return (
    <div className="user-nav">
      <a
        className="user-nav__link"
        onClick={(e) => {
          trackClickEvent('top_navigation_hook_click', e);
        }}
        href="/account"
      >
        <Profile />
        <span>&nbsp;My Account</span>
      </a>
      <button
        className={clsx(
          'cart-overlay-trigger',
          cartOverlayIsVisible && 'active',
        )}
        onClick={(e) => {
          toggleCartOverlayVisibility();
          trackClickEvent('toggle_cart_overlay_visibility');
          trackClickEvent('top_navigation_hook_click', e);
        }}
      >
        <div
          className="user-nav__link"
          onClick={(e) => {
            trackClickEvent('top_navigation_hook_click', e);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              trackClickEvent('top_navigation_hook_click', e);
            }
          }}
          tabIndex="0"
          role="button"
        >
          <Cart />
          &nbsp;<span>Cart</span> ({totalQuantity})
        </div>
      </button>
      <CartOverlay
        visibility={cartOverlayIsVisible}
        toggleCartOverlayVisibility={toggleCartOverlayVisibility}
      />
    </div>
  );
}
